@import "../../../globalStyles/commons";

:host {
  display: block;
}


.sidenav {
  width: 16rem;
  background: var(--background);
}
